import { render } from "./PersonalData.vue?vue&type=template&id=1042bf44&scoped=true"
const script = {}

import "./PersonalData.vue?vue&type=style&index=0&id=1042bf44&scoped=true&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1042bf44"]])

export default __exports__